import { action } from 'typesafe-actions';
import { GiroWebappError } from '../../../model/error';
import { InviteToCreateProviderRequest, ProviderCreatedByInvite } from '../../../model/invite';
import { ProviderByInviteActionTypes } from './types';

export const createProviderRequest = (request: InviteToCreateProviderRequest) => action(ProviderByInviteActionTypes.CREATE_PERSON_REQUEST, request);
export const createProviderSuccess = (person: ProviderCreatedByInvite) => action(ProviderByInviteActionTypes.CREATE_PERSON_SUCCESS, person);
export const createProviderError = (error: GiroWebappError) => action(ProviderByInviteActionTypes.CREATE_PERSON_ERROR, error);